import React from 'react'
import SettingShippingCarrierPage from './SettingShippingCarrierPage'

function SettingShippingCarrierContainer(props) {
    return (
        <div className="SettingShippingRuleContainer">
            <SettingShippingCarrierPage/>
        </div>
    )
}

export default SettingShippingCarrierContainer